import React, {useEffect, useState} from 'react';
import {Col, FormGroup, Input, Nav, NavItem, NavLink, Row} from "reactstrap";
import Accordion from 'react-bootstrap/Accordion';
import Select from "react-select";
import Switch from "react-switch";
import {getSubCategories, setProductFilter, setProductSubCategory} from "../../store/prodcutSlice";
import {useDispatch} from "react-redux";
import InputRange from 'react-input-range';
import CustomInputRange from "../../../../share-components/ui/customInputRange";
import ScrollArea from 'react-scrollbar';
import {CheckCircle, Delete, Info, MoreHorizontal, RefreshCcw, Target} from "react-feather";
import {DateRange} from "../../../../constant";
import DateRangePicker from "../../../../share-components/ui/DateRange";
import moment from "moment/moment";
import {convertDateFormat, dateFormat} from "../../../../utils/common";
import DatePicker from '../../../../share-components/ui/DateRangePicker';
import "../../../../assets/scss/components/accordian.scss"


function ProductFilter(props) {
    const dispatch = useDispatch();
    const {productState, customStyles,clearSelectAll,currentUser} = props;
    const productSettings = productState.productIndexSettings;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isCollectionMenuOpen, setCollectionIsMenuOpen] = useState(false);
    const [isSubCatergoryMenuOpen, setSubCatergoryMenuOpen] = useState(false);
    const [isStyleMenuOpen, setStyleMenuOpen] = useState(false);
    const [isTagTypeMenuOpen, setTagTypeMenuOpen] = useState(false);
    const [isTagsMenuOpen, setTagsMenuOpen] = useState(false);
    const [isSeasonMenuOpen, setSeasonsMenuOpen] = useState(false);
    const [isCountryMenuOpen, setCountrysMenuOpen] = useState(false);
    const [isCompositionsMenuOpen, setCompositionsMenuOpen] = useState(false);
    const [isCommodityMenuOpen, setCommodityMenuOpen] = useState(false);
    const [isColourMenuOpen, setColourMenuOpen] = useState(false);
    const [isProductGroupMenuOpen, setProductGroupMenuOpen] = useState(false);

    


    document.addEventListener("mousedown", (event) => {
        const concernedElement = document.querySelector(".customizer-contain");
            if(concernedElement) {
                if (!concernedElement.contains(event.target)) {
                    document.querySelector(".customizer-contain").classList.remove('open');
                }
            }

    });


    const [dateRange, setDateRange] = useState([convertDateFormat( productState.filter.holiday_mode_date_range?.startDate),convertDateFormat(productState.filter.holiday_mode_date_range?.endDate)]);;

    return (
        <>
            <div style={{height: '1000'}}>
                <ScrollArea
                    horizontal={false}
                    vertical={true}
                >
                     <Row>
                     {(currentUser.modules).includes('is-has-pack') && <Col md="12">
                             <Nav tabs className="border-tab">
                                 <NavItem><NavLink
                                     className={productState.filter.variant_type==="" ? "active" : ""}
                                     onClick={() => {
                                         dispatch(setProductFilter({
                                             ...productState.filter,        // dispatch(setProductFilter({
                                             variant_type: "",
                                         }));
                                         clearSelectAll();
                                     }}> ALL</NavLink></NavItem>
                                 <NavItem><NavLink
                                     className={productState.filter.variant_type?.id === 1 ? "active" : ""}
                                     onClick={() => {
                                         dispatch(setProductFilter({
                                             ...productState.filter,        // dispatch(setProductFilter({
                                             variant_type: {id:1,name:"Pack"}
                                         }));
                                         clearSelectAll();
                                     }}> Pack </NavLink></NavItem>
                                 <NavItem><NavLink
                                     className={productState.filter.variant_type?.id === 2 ? "active" : ""}
                                     onClick={() => {
                                         dispatch(setProductFilter({
                                             ...productState.filter,        // dispatch(setProductFilter({
                                             variant_type: {id:2,name:"Single"}
                                         }));
                                         clearSelectAll();
                                     }}> Single </NavLink></NavItem>
                             </Nav>
                         </Col>}
                     </Row>

    <Accordion style={{marginBottom:'60px'}} defaultActiveKey={['0']} alwaysOpen  className="custom-accordion">
        <Accordion.Item eventKey="0">
            <Accordion.Header>General</Accordion.Header>
            <Accordion.Body>
          
            <Row  style={{marginTop:-10}}>
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Category*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.category}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,
                                    category: e,
                                    subCategory: "",
                                    styles: ""
                                }));
                                clearSelectAll();
                                if (e === null) {
                                  setIsMenuOpen(false);
                                }
                            }}
                            isClearable={true}
                            placeholder="select Categories"
                        // styles={customStyles}
                            menuIsOpen={isMenuOpen}
                            onMenuOpen={() => setIsMenuOpen(true)}
                            onMenuClose={() => setIsMenuOpen(false)}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            options={productSettings.categories.filter(function (value, index) {
                                return value.parent_id == 0
                            })}/>
                </Col>
            </Row>
             <Row  className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Category*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.collection}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,
                                    collection: e,
                                }));
                                clearSelectAll();
                                if (e === null) {
                                    setCollectionIsMenuOpen(false);
                                }
                            }}
                            isClearable={true}
                            placeholder="select Collection"
                        // styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            menuIsOpen={isCollectionMenuOpen}
                            onMenuOpen={() => setCollectionIsMenuOpen(true)}
                            onMenuClose={() => setCollectionIsMenuOpen(false)}
                            options={productSettings.collections
                                .slice() 
                                .sort((a, b) => a.title.localeCompare(b.title)) 
                                .map((item) => ({
                                    id: item.id,
                                    name: item.title
                                }))}/>
                </Col>
            </Row>
            {productState.filter.category && <Row className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Sub Category*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.subCategory}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,
                                    subCategory: e,
                                    styles: ""
                                }));
                                clearSelectAll();
                                if (e === null) {
                                    setSubCatergoryMenuOpen(false);
                                }
                            }}
                            isClearable={true}
                            placeholder="select Sub Categories"
                        // styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            menuIsOpen={isSubCatergoryMenuOpen}
                            onMenuOpen={() => setSubCatergoryMenuOpen(true)}
                            onMenuClose={() => setSubCatergoryMenuOpen(false)}
                            options={productSettings.categories.filter(function (value, index) {
                                return value.parent_id == productState.filter.category?.id
                            })}/>
                </Col>
            </Row>}
            {productState.filter.subCategory && <Row className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Tag*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            isMulti={true}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.styles}
                            getOptionValue={(option) => option.id}
                            isOptionDisabled={() => productState.filter.styles && productState.filter.styles.length > 4}
                            onChange={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,
                                    styles: e.length > 0 ? e : "",
                                }));
                                clearSelectAll();
                                if (e === null) {
                                    setStyleMenuOpen(false);
                                }
                            }}
                            placeholder="select styles"
                        // styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            menuIsOpen={isStyleMenuOpen}
                            onMenuOpen={() => setStyleMenuOpen(true)}
                            onMenuClose={() => setStyleMenuOpen(false)}
                            options={productSettings.styles.filter(function (value, index) {
                                return (value.category).filter(function (v, i) {
                                    return v.id == productState.filter.subCategory?.id
                                }).length > 0
                            })}/>
                </Col>
            </Row>}
            <Row className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Category*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.tag_type}
                            getOptionValue={(option) => option.id}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            onChange={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,
                                    tag_type: e
                                }));
                                clearSelectAll();
                                if (e === null) {
                                    setTagTypeMenuOpen(false);
                                }
                            }}
                            isClearable={true}
                            placeholder="select Tag Type"
                        // styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            menuIsOpen={isTagTypeMenuOpen}
                            onMenuOpen={() => setTagTypeMenuOpen(true)}
                            onMenuClose={() => setTagTypeMenuOpen(false)}
                            options={productSettings.tag_settings}/>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Tag*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            isMulti={true}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.tags}
                            getOptionValue={(option) => option.id}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            onChange={(e) => {
                                if (!e || e.length === 0) {
                                    dispatch(setProductFilter({
                                      ...productState.filter,
                                      tags: ""
                                    }));
                                    setTagsMenuOpen(false);
                                  } else {
                                    dispatch(setProductFilter({
                                      ...productState.filter,
                                      tags: e
                                    }));
                                  }
                            }}
                            isOptionDisabled={() => productState.filter.tags && productState.filter.tags.length > 4}
                            placeholder="select tags"
                        // styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            menuIsOpen={isTagsMenuOpen}
                            onMenuOpen={() => setTagsMenuOpen(true)}
                            onMenuClose={() => setTagsMenuOpen(false)}
                            options={productSettings.tags}/>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Tag*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.season}
                            isClearable={true}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,
                                    season: e,
                                }));
                                clearSelectAll();
                                if (e === null) {
                                    setSeasonsMenuOpen(false);
                                }
                            }}
                            placeholder="select season"
                        // styles={customStyles}
                            menuIsOpen={isSeasonMenuOpen}
                            onMenuOpen={() => setSeasonsMenuOpen(true)}
                            onMenuClose={() => setSeasonsMenuOpen(false)}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            options={productSettings.seasons}/>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Tag*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.country}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,
                                    country: e,
                                }));
                                clearSelectAll();
                                if (e === null) {
                                    setCountrysMenuOpen(false);
                                }
                            }}
                            isClearable={true}
                            placeholder="select country"
                        // styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            menuIsOpen={isCountryMenuOpen}
                            onMenuOpen={() => setCountrysMenuOpen(true)}
                            onMenuClose={() => setCountrysMenuOpen(false)}
                            options={productSettings.countries}/>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Tag*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            isMulti={true}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.compositions}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => {
                                if (!e || e.length === 0) {
                                    // Cleared
                                    dispatch(setProductFilter({
                                      ...productState.filter,
                                      compositions: ""
                                    }));
                                    setCompositionsMenuOpen(false);
                                  } else {
                                    // Selected items
                                    dispatch(setProductFilter({
                                      ...productState.filter,
                                      compositions: e
                                    }));
                                  }
                            }}
                            isOptionDisabled={() => productState.filter.compositions && productState.filter.compositions.length > 4}
                            placeholder="select compositions"
                        // styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            menuIsOpen={isCompositionsMenuOpen}
                            onMenuOpen={() => setCompositionsMenuOpen(true)}
                            onMenuClose={() => setCompositionsMenuOpen(false)}
                            options={productSettings.compositions}/>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Tag*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.commodity}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,
                                    commodity: e,
                                }));
                                clearSelectAll();
                                if (e === null) {
                                    setCommodityMenuOpen(false);
                                }
                            }}
                            placeholder="select commodity"
                            isClearable={true}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            menuIsOpen={isCommodityMenuOpen}
                            onMenuOpen={() => setCommodityMenuOpen(true)}
                            onMenuClose={() => setCommodityMenuOpen(false)}
                            options={productSettings.commodities}/>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="12">
                    {/*<div className="product-filter pb-0">*/}
                    {/*    <h6 className="f-w-600">Tag*/}
                    {/*    </h6>*/}
                    {/*</div>*/}
                    <Select getOptionLabel={(option) => option.name}
                            className="select2-filter"
                            menuPortalTarget={document.body}
                            styles={{menuPortal: base => ({...base, zIndex: 100})}}
                            value={productState.filter.colour}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,
                                    colour: e,
                                }));
                                clearSelectAll();
                                if (e === null) {
                                    setColourMenuOpen(false);
                                }
                            }}
                            filterOption={(option, inputValue) =>
                                option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            placeholder="select Colour"
                            isClearable={true}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            menuIsOpen={isColourMenuOpen}
                            onMenuOpen={() => setColourMenuOpen(true)}
                            onMenuClose={() => setColourMenuOpen(false)}
                            options={productSettings.colours}/>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col md="12">
                    <Select getOptionLabel={(option) => option.name}
                        className="select2-filter"
                        menuPortalTarget={document.body}
                        styles={{menuPortal: base => ({...base, zIndex: 100})}}
                        value={productState.filter.product_group}
                        getOptionValue={(option) => option.id}
                        onChange={(e) => {
                            dispatch(setProductFilter({
                                ...productState.filter,
                                product_group: e,
                            }));
                            clearSelectAll();
                            if (e === null) {
                                setProductGroupMenuOpen(false);
                            }
                        }}
                        placeholder="Select Group Product"
                        isClearable={true}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        filterOption={(option, inputValue) =>
                            option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                        }
                        menuIsOpen={isProductGroupMenuOpen}
                        onMenuOpen={() => setProductGroupMenuOpen(true)}
                        onMenuClose={() => setProductGroupMenuOpen(false)}
                        options={productSettings.group_products}
                    />
                </Col>
            </Row>

            <Row style={{marginTop:15}}>
                <Col md="12">
                    <div className="">
                        {/* <div className="product-filter pb-0">
                            <h6 className="f-w-600">Empty Field Check
                            </h6>
                        </div> */}
                        <Input type="select" name="select" onChange={(e) => {
                            dispatch(setProductFilter({
                                ...productState.filter,
                                null_check: e.target.value ? {
                                    id: e.target.value,
                                    name: e.target.options[e.target.selectedIndex].text
                                } : ""
                            }))
                            clearSelectAll();
                        }} className="form-control digits" value={productState.filter.null_check?.id}>
                            <option value="">Select Empty Field</option>
                            <option value="1-description">Description</option>
                            <option value="1-summary">Summary</option>
                            <option value="2-tag">Tag</option>
                            <option value="1-custom_tags">Handel</option>
                            <option value="1-available_in_length">Other Type</option>
                            <option value="1-available_in_fit">Other Style</option>
                            <option value="1-taxonomy_id">Standard Product Type</option>
                            <option value="2-style">Style</option>
                            <option value="1-commodity_id">Commodity</option>
                            <option value="1-weight_value">Weight</option>
                            <option value="1-hs_code">Hs Code</option>
                            <option value="2-composition">Composition</option>
                            <option value="1-sale_price">Sale Price</option>


                        </Input>
                    </div>
                </Col>
                <Col md={6} className="mt-2">
                        <label style={{marginTop: 8, marginLeft: 4}}>Test Products</label>
                        <FormGroup style={{marginTop: 1, marginLeft: 4}}>
                        <Switch
                            checked={productState.filter.is_test}
                            onChange={(e) => {
                            dispatch(setProductFilter({
                                ...productState.filter,
                                is_test: e,
                            }));
                            clearSelectAll();
                        }}
                            className="react-switch"
                            uncheckedIcon={false}
                            checkedIcon={false}
                        />
                    </FormGroup>
                </Col>
            </Row>

            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
            <Accordion.Header>Inventory</Accordion.Header>
            <Accordion.Body>
            <Row className="mt-1">
                <Col md="12">
                    <div className="product-filter pb-0">

                        <div style={{marginTop:-15, padding: '10px'}}>
                            <CustomInputRange
                                title="Stock"
                                maxRange={2000}
                                stateValue={productState.filter.stock}
                                clearRange={() => {
                                    dispatch(setProductFilter({
                                        ...productState.filter,        // dispatch(setProductFilter({
                                        stock: "",
                                    }));
                                    clearSelectAll();
                                }}
                                rangeComplete={(e) => {
                                    dispatch(setProductFilter({
                                        ...productState.filter,        // dispatch(setProductFilter({
                                        stock: e,
                                    }));
                                    clearSelectAll();

                                }}
                            >

                            </CustomInputRange>
                        </div>

                    </div>
                </Col>
            </Row>
            <Row style={{marginTop: -50, padding: '10px'}}>
                <Col md="12">
                    <div className="product-filter pb-0">
                        <CustomInputRange
                            title="Price"
                            maxRange={500}
                            stateValue={productState.filter.price}
                            clearRange={() => {
                                dispatch(setProductFilter({
                                    ...productState.filter,        // dispatch(setProductFilter({
                                    price: "",
                                }));
                                clearSelectAll();
                            }}
                            rangeComplete={(e) => {
                                dispatch(setProductFilter({
                                    ...productState.filter,        // dispatch(setProductFilter({
                                    price: e,
                                }));
                                clearSelectAll();

                            }}
                        >

                        </CustomInputRange>
                    </div>
                </Col>
            </Row>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
            <Accordion.Header>Sales</Accordion.Header>
            <Accordion.Body>
            <Row className="mt-2" >
                <Col md="12">
                    <Nav tabs className="border-tab">
                        <NavItem><NavLink
                            className={productState.filter.offer_type==="" ? "active" : ""}
                            onClick={() => {
                                dispatch(setProductFilter({
                                    ...productState.filter,        // dispatch(setProductFilter({
                                    offer_type: "",
                                }));
                                clearSelectAll();
                            }}> ALL</NavLink></NavItem>
                        <NavItem><NavLink
                            className={productState.filter.offer_type?.id === 1 ? "active" : ""}
                            onClick={() => {
                                dispatch(setProductFilter({
                                    ...productState.filter,        // dispatch(setProductFilter({
                                    offer_type: {id:1,name:"Yes"}
                                }));
                                clearSelectAll();
                            }}>Sales </NavLink></NavItem>
                        <NavItem><NavLink
                            className={productState.filter.offer_type?.id === 2 ? "active" : ""}
                            onClick={() => {
                                dispatch(setProductFilter({
                                    ...productState.filter,        // dispatch(setProductFilter({
                                    offer_type: {id:2,name:"No"}
                                }));
                                clearSelectAll();
                            }}> Non</NavLink></NavItem>
                    </Nav>
                </Col>
            </Row>
            <Row className="mb-5">
                <Col md="12">
                    <div className="product-filter pb-0" style={{padding: '10px'}}>
                        <h6 className="f-w-600">Holiday Mode
                        </h6>
                    </div>
                </Col>
                <Col md="2">
                    <div className="mt-2" style={{padding: '10px'}}>
                    <input  checked={productState.filter.holiday_mode_date_range?true:false} type="checkbox" onChange={(e) => {

                            const startDate = e.target.checked?new Date():"";
                            const endDate =e.target.checked? new Date().setDate(startDate.getDate() + 30):"";
                            dispatch(setProductFilter({
                                ...productState.filter,
                                holiday_mode_date_range:e.target.checked? {startDate:dateFormat(startDate) , endDate:dateFormat(endDate) }:"",

                            }));
                            setDateRange([startDate, endDate]);
                            clearSelectAll();

                    }}/>
                    </div>
                </Col>
                <Col md="10">
                    {productState.filter.holiday_mode_date_range &&<DatePicker 
                        dateRange={dateRange} 
                        placement="leftEnd"
                        defaultValue={dateRange}
                        dateRangeChange={(date)=>{
                            
                            setDateRange(date);
                        if(date[0] && date[1]) {
                            dispatch(setProductFilter({
                                ...productState.filter,
                                holiday_mode_date_range: {
                                    startDate: dateFormat(date[0]),
                                    endDate: dateFormat(date[1])
                                }

                            }));
                            clearSelectAll();

                        }
                    }} />}
                </Col>
            </Row>
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>

           



        </ScrollArea>
            </div>

        </>
    );
}

export default ProductFilter;